<template>
    <div class="mysub">
        <myScroll class="scroll">
            <div class="myprofile">
                <div class="mptitle">个人信息</div>
                <dl class="mpinput">
                    <dt>注册邮箱：</dt>
                    <dd class="a">{{myinfo.username}}</dd>
                </dl>
                <dl class="mpinput">
                    <dt>我的昵称：</dt>
                    <dd v-if="parpage.id==0" class="a">{{myinfo.showname}}</dd>
                    <dd v-else>
                        <el-input :maxlength="20" v-model="myinfo.showname"></el-input>
                    </dd>
                </dl>
                <dl class="mpinput">
                    <dt>真实姓名：</dt>
                    <dd v-if="parpage.id==0" class="a">{{myinfo.realname}}</dd>
                    <dd v-else>
                        <el-input :maxlength="20" v-model="myinfo.realname"></el-input>
                    </dd>
                </dl>
                <dl class="mpinput">
                    <dt>手机号码：</dt>
                    <dd v-if="parpage.id==0" class="a">{{myinfo.mobile}}</dd>
                    <dd v-else>
                        <el-input :maxlength="20" v-model="myinfo.mobile" @change="checkmobile"></el-input>
                    </dd>
                </dl>
                <dl class="mpinput">
                    <dt>联系地址：</dt>
                    <dd v-if="parpage.id==0" class="a">{{myinfo.addr}}</dd>
                    <dd v-else>
                        <el-input :maxlength="200" v-model="myinfo.addr"></el-input>
                    </dd>
                </dl>
                <dl class="mpinput">
                    <dt>身份证号：</dt>
                    <dd v-if="parpage.id==0" class="a">{{myinfo.idcard}}</dd>
                    <dd v-else>
                        <el-input :maxlength="18" v-model="myinfo.idcard" @change="checkidcard"></el-input>
                    </dd>
                </dl>

                <dl class="mpinput">
                    <dt>出生日期：</dt>
                    <dd v-if="parpage.id==0" class="a">{{$common.basic.dateformat(myinfo.birth)}}</dd>
                    <dd v-else>
                        <el-date-picker type="date" class="fullwidth" v-model="myinfo.birth" value-format="yyyy-MM-dd"></el-date-picker>
                    </dd>
                </dl>
                <dl class="mpinput">
                    <dt>性别：</dt>
                    <dd v-if="parpage.id==0" class="a">{{$common.chgender(myinfo.gender)}}</dd>
                    <dd v-else>
                        <el-radio-group v-model="myinfo.gender">
                            <el-radio-button :label="1">男</el-radio-button>
                            <el-radio-button :label="2">女</el-radio-button>
                        </el-radio-group>
                    </dd>
                </dl>

                <div class="mpinput">
                    <a href="#" v-if="parpage.id==0" class="btn1full" @click="gopagesub(1)">修改</a>
                    <a href="#" v-else class="btn1full" @click="save()">保存</a>
                </div>

                <div class="mplink" v-if="$store.getters.issmall">

                    <a href="#" class="linkbtn" @click="isshowavatar=true">修改头像</a>

                    <a href="#" class="linkbtn" @click="$common.logout()">退出登录</a>

                </div>

            </div>
        </myScroll>

        <el-dialog v-if="isshowavatar && $store.state.islogin" :visible.sync="isshowavatar" top="0px" :append-to-body="true">
            <div class="myavatar modulewrap">
                <div class="title">头像修改</div>
                <div class="con">
                    <ffupload :fileurl="myavatar" @update:fileurl="updateface" :updata="{'mediatype':'avatar'}"></ffupload>
                </div>
            </div>
        </el-dialog>

    </div>


</template>

<script>
    import { mixinpage } from "@/mixin/mixin"

    export default {
        name: 'Cprofile',
        mixins: [mixinpage],
        data() {
            return {
                myinfo: {},
                isshowavatar: false,
                myavatar: this.$store.state.avatar
            };
        },
        methods: {
            save: function () {
                if (this.myinfo.mobile) {
                    if (this.$common.validate(this.myinfo.mobile, "ismobile") == -1) {
                        this.$common.alert('手机号码不正确');
                        return false;
                    }
                }
                if (this.myinfo.idcard) {
                    if (this.$common.validate(this.myinfo.idcard, "isidcard") == -1) {
                        this.$common.alert('身份证号不正确');
                        return false;
                    }
                }
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofilesave', 'data': this.myinfo } };
                this.$common.post(jsondata, () => {
                    this.$store.dispatch('setshowname', this.myinfo.showname);
                    this.gopagesub(0);
                });
            },
            checkmobile: function () {
                if (this.myinfo.mobile) {
                    if (this.$common.validate(this.myinfo.mobile, "ismobile") == -1) {
                        this.$common.alert('手机号码不正确');
                    }
                }
            },
            checkidcard: function () {
                if (this.myinfo.idcard) {
                    if (this.$common.validate(this.myinfo.idcard, "isidcard") == -1) {
                        this.$common.alert('身份证号不正确');
                    }
                    else {
                        this.myinfo.birth = (this.myinfo.idcard.substring(6, 10) + "-" + this.myinfo.idcard.substring(10, 12) + "-" + this.myinfo.idcard.substring(12, 14));
                        this.myinfo.gender = (parseInt(this.myinfo.idcard.substring(16, 17)) % 2) == 1 ? 1 : 2;
                    }
                }
            },
            updateface: function (v) {
                this.myavatar = v;
                this.$store.dispatch('setavatar', this.myavatar);
            }
        },
        mounted() {
            let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofile' } };
            this.$common.post(jsondata, res => {
                res.infodata.birth = this.$common.basic.dateformat(res.infodata.birth);
                this.myinfo = res.infodata || {};
            });
        }
    }
</script>
